import 'antd/dist/antd.min.css'
import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, useHistory, RouteProps } from 'react-router-dom'
import './App.css'
import { Dashboard, Login } from './pages'
import { AuthReducerState, IApplicationState } from './state/ducks'

interface PrivateRouteProps extends RouteProps {
    component: any
    isAuthenticated: boolean
}

export const PrivateRoute: React.FC<PrivateRouteProps> = (props) => {
    const { component, isAuthenticated, ...rest } = props

    const routeComponent = (props: any) =>
        isAuthenticated ? React.createElement(component, props) : <Redirect to={{ pathname: '/' }} />
    return <Route {...rest} render={routeComponent} />
}

const App: React.FC = (props) => {
    const history = useHistory()

    const auth = useSelector<IApplicationState, AuthReducerState>(
        (state) => state.auth,
        (a: AuthReducerState, b: AuthReducerState) => a.access_token === b.access_token
    )

    React.useEffect(() => {
        if (!auth.access_token) {
            history.push('/')
        }
    }, [auth, history])

    return (
        <>
            <Route exact path="/" component={Login} />
            <PrivateRoute path="/dashboard" component={Dashboard} isAuthenticated={!!auth.access_token} />
        </>
    )

    // return (
    //     <AuthContext.Provider
    //         value={{
    //             state,
    //             dispatch,
    //         }}
    //     >
    //         <div className="App">
    //             {!state.isAuthenticated ? (
    //                 <Login />
    //             ) : (
    //                 <Router>
    //                     <Drawer />
    //                 </Router>
    //             )}
    //         </div>
    //     </AuthContext.Provider>
    // )
}

export default App
